import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AuthService } from './../../../../services/API/auth/auth.service';
import { Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder, Validators} from '@angular/forms';
import { NotificationServiceService } from './../../../../services/notification-service/notification-service.service';

@Component({
    selector: 'app-recover',
    templateUrl: './recover.component.html',
    styleUrls: ['./recover.component.css'],
    standalone: false
})
export class RecoverComponent implements OnInit {

  loginForm: UntypedFormGroup;
  loginEmail: string = "";

  loading: boolean = false;
  hideForm: boolean = true;

  constructor(private fb: UntypedFormBuilder, public router: Router, private authService: AuthService, private notificationService: NotificationServiceService) {
  }

  ngOnInit() {

    this.loginForm = this.fb.group({
      loginEmail: [this.loginEmail, [Validators.required, Validators.minLength(1), Validators.maxLength(255), Validators.pattern("[a-z0-9._%+-]+@[a-z0-9.-]+\.+[a-z]{2,4}$")]],
    });

    this.loginForm.controls['loginEmail'].setValue((localStorage.getItem('appEmail') || ""));

  }

  sendRecoverymail() {
    const {valid} = this.loginForm;
    if(valid){
      this.loading = true;

      setTimeout(()=>{
        this.loading = false;
      }, 5000);

      var email = this.loginForm.controls['loginEmail'].value;

      this.authService.recover(email).subscribe(data => {

        this.loading = false;
        this.notificationService.openSnackBar("¡Hemos enviado un correo de recuperación a tu e-mail!");

        this.hideForm = false;

      }, error => {
        this.notificationService.openSnackBar("¡Se ha producido un error!");
        this.loading = false;
      });
    }
  }

}
